const getRestaurantId = (location) =>
  location.state?.restaurantId ||
  location.pathname.split("restaurants/")[1].split("/")[0];

export default getRestaurantId;
